import { useEffect, useLayoutEffect } from 'react';

import { css, injectGlobal } from '@emotion/css';
import {
  colorLight,
  colorDark,
  typography,
  primitives,
} from '@fastly/beacon-tokens';

export function useTokenly() {
  useLayoutEffect(() => {
    document.body.classList.add('tokenly-poc');

    return injectGlobal`
        body.tokenly-poc[data-theme="summit"] {
          ${css(primitives)};
          ${css(typography)};
          ${css(colorLight)};
        }

        body.tokenly-poc[data-theme="summit"][data-prefers-color-scheme="dark"] {
          ${css(colorDark)};
        }
      `;
  });
}

export const Tokenly = ({ mode }: { mode: 'dark' | 'light' }) => {
  useTokenly();
  useEffect(() => {
    document.body.classList.add('tokenly-poc');
    document.body.setAttribute('data-theme', 'summit');
    document.body.setAttribute('data-prefers-color-scheme', mode);
  });
  return null;
};
